import { ReserveBtn } from "../styles/Buttons";
import { ProductWrapper } from "../styles/Layouts";
import { PriceText, ProductTitle } from "../styles/Typography";
import DetailsPopup from "./DetailsPopup";
import { useState } from "react";

const ProductCard = (props) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const products = props.product;

  return (
    <ProductWrapper>
      <ProductTitle>{products.title}</ProductTitle>
      <ProductTitle>—</ProductTitle>
      <PriceText>{products.price}€</PriceText>
      <ReserveBtn onClick={() => setIsPopupOpen(true)}>Reserve</ReserveBtn>
      {/* Image from emma goes here !in a flex-direction: column!*/}
      {isPopupOpen && <DetailsPopup product={products} onClose={() => setIsPopupOpen(false)} />}
    </ProductWrapper>
  );
};

export default ProductCard;
